import { Injectable } from '@angular/core';
import { RepositoryBase } from '@asm/features/sync/repositories/repository-base';
import { PISTaxTable } from '@asm/features/sync/models/pricing-tables.model';

@Injectable({ providedIn: 'root' })
export class PISRepository extends RepositoryBase<PISTaxTable> {
  protected readonly KEY_PATH = 'pis';
}
